// extracted by mini-css-extract-plugin
export var displayNone = "_rs-6";
export var imgContainer = "_rs-2";
export var overflowHidden = "_rs-3";
export var productInfoCardButtonContainer = "_rs-5";
export var productTitleText = "_rs-4";
export var rightArrow = "_rs-1";
export var rightArrowContainer = "_rs-0";